import axios from "axios";
import { getAuthHeader } from "../../utils/authHeader";
import {
    FailedPostSortColumn,
    PaginatedFailedPosts,
    RescheduleResult,
    SortDirection,
} from "./types";

export interface GetFailedPostsParams {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
    platform?: string;
    sortBy?: FailedPostSortColumn;
    sortDirection?: SortDirection;
    from?: string;
    to?: string;
}

export async function getFailedPosts({
    page = 1,
    limit = 10,
    search = "",
    status = "All",
    platform = "All",
    sortBy,
    sortDirection = "asc",
    from,
    to,
}: GetFailedPostsParams = {}): Promise<PaginatedFailedPosts> {
    try {
        const headers = await getAuthHeader();

        const params: Record<string, string | number> = { page, limit };
        if (search.trim()) params.search = search.trim();
        if (status && status !== "All") params.status = status;
        if (platform && platform !== "All") params.platform = platform;
        if (from) params.from = from;
        if (to) params.to = to;
        if (sortBy) {
            params.sortBy = sortBy;
            params.sortDirection = sortDirection;
        }

        const response = await axios.get<PaginatedFailedPosts>(
            `${process.env.REACT_APP_BACKEND_URL}/admin/failed-posts`,
            { params, headers }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching failed posts:", error);
        throw new Error("Error fetching failed posts");
    }
}

export async function reschedulePosts(
    postIds: string[],
    scheduledFor?: string
): Promise<RescheduleResult[]> {
    try {
        const headers = await getAuthHeader();

        const response = await axios.patch<RescheduleResult[]>(
            `${process.env.REACT_APP_BACKEND_URL}/admin/reschedule-posts`,
            { postIds, ...(scheduledFor ? { scheduledFor } : {}) },
            { headers }
        );

        return response.data;
    } catch (error) {
        console.error("Error rescheduling posts:", error);
        throw new Error("Error rescheduling posts");
    }
}
